import React from 'react';
import '../styles/sonstige/about_me.css';
import media from '../util/img_loader.js';

function Body_about() {
    return (
        <>
            {/* === ÜBER MICH === */}
            <section className="about-container">
                <div className="about-image">
                    <img src={media['fotos/about me.png']} alt="Über mich" />
                    <div className="image-overlay">
                        <h2>Nurleder</h2>
                    </div>
                </div>

                <div className="about-text">
                    <h1>Über mich</h1>
                    <p>
                        Ich bin Lederhandwerker in dritter Generation. Mein Großvater arbeitete mit Leder, mein Vater ebenso – und ich habe schon als Kind den Geruch der Werkstatt geliebt, das Geräusch des Schnitts, das Gefühl des Materials in der Hand.
                        <br /><br />
                        Lange Zeit war die Arbeit mit Leder für mich ein Hobby, ein Ausgleich – etwas, das ich aus Leidenschaft tat. Doch seit über 7 Jahren ist sie mein Beruf, mein tägliches Handwerk und meine größte Freude.
                        <br /><br />
                        In jedem Stück, das ich herstelle, steckt Erfahrung, Sorgfalt und ein tiefer Respekt vor dem Material. Ich arbeite mit Leder, das lebt – mit all seinen kleinen Unregelmäßigkeiten, seinen Geschichten und seiner natürlichen Schönheit.
                        <br /><br />
                        Mein Ziel ist es, Produkte zu schaffen, die nicht nur gut aussehen, sondern sich gut anfühlen, die lange halten und mit der Zeit nur noch schöner werden. Originalität, Stabilität und handwerkliche Präzision stehen bei mir an erster Stelle.
                        <br /><br />
                        Ich möchte, dass man sieht und spürt: Das ist echte Handarbeit. Mit Herz gemacht.
                    </p>
                </div>
            </section>

            <hr className="section-divider" />

            {/* === LEDER-INFO === */}
            <section className="leather-section">

                <h1>Leder, mit dem ich arbeite</h1>
                <p>
                    Für meine handgefertigten Produkte verwende ich ausschließlich pflanzlich gegerbtes Leder aus Deutschland, Norwegen und Italien. Dieses Leder wird traditionell mit natürlichen Gerbstoffen aus Rinde, Blättern und Früchten behandelt – ganz ohne aggressive Chemikalien.
                    <br /><br />
                    Pflanzlich gegerbtes Leder ist eine umweltfreundliche und nachhaltige Wahl. Es ist langlebig, entwickelt im Laufe der Zeit eine schöne Patina und erzählt mit jeder Spur eine eigene Geschichte. Die natürliche Oberfläche bleibt sichtbar – kleine Narben und Strukturen machen jedes Stück einzigartig.
                    <br /><br />
                    Ich arbeite nur mit ausgewählten Gerbereien, die höchsten Qualitätsstandards folgen und umweltbewusst produzieren. Jede Lieferung wird sorgfältig geprüft – auf Haptik, Farbe, Stärke und Struktur.
                    <br /><br />
                    Kunstleder oder industriell behandeltes Leder kommen für mich nicht in Frage. Mein Ziel ist es, Produkte zu schaffen, die nicht nur gut aussehen, sondern auch über viele Jahre halten – ehrlich, hochwertig und verantwortungsvoll hergestellt.
                </p>

                <h2>🌍 Pflanzlich gegerbte Lederarten nach Herkunft</h2>

                <div className="leather-type">
                    <h3>🇩🇪 Deutschland – robust & traditionsbewusst</h3>
                    <ul>
                        <li><strong>Charakter:</strong> Sehr gleichmäßig, strukturiert, meist mit etwas festerer Haptik</li>
                        <li><strong>Besonderheiten:</strong> Strenge Umwelt- und Qualitätsstandards</li>
                        <li><strong>Ideal für:</strong> Gürtel, Riemen, Taschen mit Struktur</li>
                        <li><strong>Farben:</strong> Oft naturbelassen, Cognac, Braun</li>
                        <li><strong>Patina:</strong> Entwickelt sich langsam, aber intensiv</li>
                    </ul>
                </div>

                <div className="leather-type">
                    <h3>🇳🇴 Norwegen – klar & naturbelassen</h3>
                    <ul>
                        <li><strong>Charakter:</strong> Glatte, etwas kühlere Oberfläche mit sichtbarer Narbenstruktur</li>
                        <li><strong>Besonderheiten:</strong> Tiere aus Freilandhaltung – oft weniger Schadstellen</li>
                        <li><strong>Ideal für:</strong> Hochwertige Einzelstücke mit natürlicher Oberfläche</li>
                        <li><strong>Farben:</strong> Hell, minimal behandelt – oft in Naturtönen</li>
                        <li><strong>Patina:</strong> Entwickelt sich zart, elegant</li>
                    </ul>
                </div>

                <div className="leather-type">
                    <h3>🇮🇹 Italien – weich & edel</h3>
                    <ul>
                        <li><strong>Charakter:</strong> Feine Narben, besonders weich, geschmeidig</li>
                        <li><strong>Besonderheiten:</strong> Kunst der traditionellen Gerbereien – oft in der Toskana</li>
                        <li><strong>Ideal für:</strong> Portemonnaies, elegante Taschen, Accessoires</li>
                        <li><strong>Farben:</strong> Reiche Auswahl – von Natur über warme Braun- und Rottöne</li>
                        <li><strong>Patina:</strong> Entwickelt sich schnell, farbintensiv, sehr lebendig</li>
                    </ul>
                </div>

                <h3>🌿 Was macht pflanzlich gegerbtes Leder besonders?</h3>
                <table className="leather-table">
                    <thead>
                        <tr>
                            <th>Merkmal</th>
                            <th>Beschreibung</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>🌱 Umweltfreundlich</td>
                            <td>Gerbung mit natürlichen Stoffen (Rinde, Früchte, Blätter)</td>
                        </tr>
                        <tr>
                            <td>🧡 Unikate</td>
                            <td>Jede Haut ist anders – Narben & Poren bleiben sichtbar</td>
                        </tr>
                        <tr>
                            <td>⏳ Altert schön</td>
                            <td>Entwickelt mit der Zeit eine charaktervolle Patina</td>
                        </tr>
                        <tr>
                            <td>🧵 Verarbeitbar</td>
                            <td>Ideal für traditionelles Handwerk – von Nähen bis Stanzen</td>
                        </tr>
                        <tr>
                            <td>❌ Keine Chemie</td>
                            <td>Frei von Chrom, Bleichmitteln & synthetischen Versiegelungen</td>
                        </tr>
                    </tbody>
                </table>

                <hr className="section-divider" />

                <div className="leather-image-wrapper">
                    <img src={media['fotos/about leder.png']} alt="Lederarten" />
                </div>
            </section>
        </>
    );
}

export default Body_about;
